import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoutes = () => {
  const { isAuthenticated, userId } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!isAuthenticated || !userId) {
    // Redirect to signin with the current path as "next"
    return (
      <Navigate
        to={`/signin?next=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  }

  // Render the nested route if authenticated
  return <Outlet />;
};

export default PrivateRoutes;
